// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SouthGeorgiaAndTheSouthSandwichIslands from '../_raw/flag/icon_flag_south_georgia_and_the_south_sandwich_islands.png';

export default () => (
  <img src={SouthGeorgiaAndTheSouthSandwichIslands} alt="SouthGeorgiaAndTheSouthSandwichIslands" />
);
